import { useRouteQuery } from 'src/common/helpers';
import { SETTINGS_PAGES } from 'src/pages/settings/settings.constants';

import { EditClientNumber } from './components/edit-client-number';
import { EditConsultantNumber } from './components/edit-consultant-number';

const EditDatevNumber = () => {
  const query = useRouteQuery();
  const id: string = query.get('id') || '';
  const pageType: string = query.get('type') || '';

  return pageType === SETTINGS_PAGES.editDatev ? (
    <EditClientNumber clientNumberId={id} />
  ) : (
    <EditConsultantNumber consultantNumberId={id} />
  );
};

export default EditDatevNumber;
